import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a87d55a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-collectible-inner" }

import { nextTick } from "process";
import { computed, onBeforeMount, onMounted, reactive, ref } from "vue";
import { RevealedToken, TransactionState, UserRejectedError } from "@manifoldxyz/collectible-sdk";
import { useCollectibleSDK } from "@/composables/useCollectibleSDK";
//import { useStore } from "@/composables/useStore";

interface ClaimCollectibleProps {
  asCarousel?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ClaimDialog',
  props: {
    asCarousel: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit }) {

const props = __props;


const componentState = reactive<{
  bodyOverflowInitial?: string;
  htmlOverflowInitial?: string;
  transactionState?: TransactionState | null;
}>({});
//const store = useStore();
const collectibleSDK = useCollectibleSDK();

const closeDialog = () => {
  emit("close");
  document.documentElement.style.overflowY = componentState.htmlOverflowInitial!;
  document.body.style.overflowY = componentState.bodyOverflowInitial!;
  document.removeEventListener("keydown", closeOnEscape);
};
const el = ref<HTMLDivElement>();
const closeOnEscape = (event: KeyboardEvent): void => {
  if (event.key === "Escape") {
    closeDialog();
  }
};

onBeforeMount(() => {
  componentState.htmlOverflowInitial = document.documentElement.style.overflowY;
  componentState.bodyOverflowInitial = document.body.style.overflowY;
  document.documentElement.style.overflowY = "hidden";
  document.body.style.overflowY = "hidden";
  document.addEventListener("keydown", closeOnEscape);
});

onMounted(() => {
  nextTick(() => {
    document.body.appendChild(el.value!);
  });
});

const claim = (quantity: number) => {
  //const quantity = store.collectibleState.claimEligibility!.amount;
  collectibleSDK.claim(
    {
      quantity,
    },
    {
      onStateChange: (transactionState) => {
        componentState.transactionState = transactionState;

        if (
          componentState.transactionState.status === "Error" &&
          componentState.transactionState.data.error instanceof UserRejectedError
        ) {
          componentState.transactionState = null;
        }
      },
    }
  );
};

const successfulTransactionData = computed(
  (): { tokens: RevealedToken[]; numMintedTokens: number; transactionHash: string } => {
    if (componentState.transactionState?.status === "Success") {
      return {
        tokens: componentState.transactionState?.data.tokens as RevealedToken[],
        numMintedTokens: componentState.transactionState?.data.tokens.length || 0,
        transactionHash: componentState.transactionState?.data.transactionHash,
      };
    }

    return {
      tokens: [] as RevealedToken[],
      numMintedTokens: 0,
      transactionHash: "",
    };
  }
);

const isSuccessfulTransaction = computed(
  () => componentState.transactionState?.status === "Success"
);

return (_ctx: any,_cache: any) => {
  const _component_ClaimConfirmationDialog = _resolveComponent("ClaimConfirmationDialog")!
  const _component_Minted = _resolveComponent("Minted")!
  const _component_PendingTransactionDialog = _resolveComponent("PendingTransactionDialog")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "el",
    ref: el,
    class: "manifold m-collectible"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        title: "Close",
        onClick: closeDialog
      }, "×"),
      (!componentState.transactionState)
        ? (_openBlock(), _createBlock(_component_ClaimConfirmationDialog, {
            key: 0,
            onClaim: claim
          }))
        : (isSuccessfulTransaction.value)
          ? (_openBlock(), _createBlock(_component_Minted, {
              key: 1,
              tokens: successfulTransactionData.value.tokens,
              "number-minted": successfulTransactionData.value.numMintedTokens,
              "transaction-hash": successfulTransactionData.value.transactionHash,
              "as-carousel": props.asCarousel,
              onClose: closeDialog
            }, null, 8, ["tokens", "number-minted", "transaction-hash", "as-carousel"]))
          : (_openBlock(), _createBlock(_component_PendingTransactionDialog, {
              key: 2,
              "transaction-state": componentState.transactionState,
              onReset: _cache[0] || (_cache[0] = ($event: any) => (componentState.transactionState = null))
            }, null, 8, ["transaction-state"]))
    ])
  ], 512))
}
}

})